if(!customElements.get('vertexa-brand-story')){
  customElements.define('vertexa-brand-story',class extends HTMLElement{
    connectedCallback(){
      if(this.observer||matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window))return;
      this.observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(!entry.isIntersecting)return;
          const item=entry.target;
          const picture=item.tagName==='FIGURE';
          item.animate(picture?[{opacity:.75,transform:'scale(.985)'},{opacity:1,transform:'scale(1)'}]:[{opacity:.55,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:picture?850:650,easing:'cubic-bezier(.16,1,.3,1)',delay:Number(item.dataset.vbaDelay||0)});
          this.observer.unobserve(item);
        });
      },{threshold:.12});
      this.querySelectorAll('[data-vba-enter]').forEach((item,index)=>{item.dataset.vbaDelay=String((index%3)*70);this.observer.observe(item)});
    }
    disconnectedCallback(){this.observer?.disconnect();this.observer=null}
  });
}
